// Simple class name utility (cn) for the Roadmap Builder UI components
export function cn(...inputs: (string | undefined | false | null)[]): string {
  return inputs.filter(Boolean).join(" ");
}
